// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"05274a75","545":"230c38d8"}[chunkId] + ".chunk.css";
};